import styled from 'styled-components';

export const Title = styled.h3`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-weight: 600;
  font-size: 18px;
  line-height: 21px;
  padding-inline-end: 24px;
`;
